module.exports = __webpack_public_path__ + "static/media/LineFooter.c84442ae.png";